module.exports = __webpack_public_path__ + "img/ELE.811e633.svg";